import { getMessages } from '../../../../../../../../store/constants';

export const MAX_BOARD_BG_FILE_SIZE = 3 * 1024 * 1024; // 3 MB

export const THEME_WRONG_FILE_SIZE_TEXT = getMessages().getText('popup.dashboard.bg.too_large');
export const THEME_WRONG_FILE_TYPE_TEXT = getMessages().getText('popup.dashboard.image_mime_mismatch');
